'use client';

import { create } from 'zustand';

export type SignUpStep = 'start' | 'email-verification' | 'choose';

interface SignUpStartFormDraft {
  emailAddress: string;
  firstName: string;
  lastName: string;
  password: string;
}

interface SignUpFlowState {
  isRedirecting: boolean;
  isStartFormVisible: boolean;
  newsletter: boolean;
  startFormDraft: SignUpStartFormDraft;
  step: SignUpStep;
}

interface SignUpFlowActions {
  onChange: (args: Partial<SignUpFlowState>) => void;
  reset: () => void;
}

type SignUpFlowStore = SignUpFlowState & SignUpFlowActions;

const initSignUpFlowStore = (): SignUpFlowState => ({
  step: 'start',
  isRedirecting: false,
  isStartFormVisible: false,
  newsletter: true,
  startFormDraft: {
    firstName: '',
    lastName: '',
    emailAddress: '',
    password: '',
  },
});

export const useSignUpFlowStore = create<SignUpFlowStore>()((set) => ({
  ...initSignUpFlowStore(),
  onChange: (args) => set((state) => ({ ...state, ...args })),
  reset: () => set(initSignUpFlowStore()),
}));
